import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppDispatch } from '@application/store/useStore';
import { Controller, useForm } from 'react-hook-form';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import VnValidation from '@ui/components/VnValidation';
import { translate } from '@application/common/helpers/translate';
import { IonIcon } from '@ionic/react';
import { eyeOffOutline, eyeOutline } from 'ionicons/icons';
import './login.css';
import { resetPasswordAsync, verifyTokenAsync } from '@application/features/auth/authThunks';
const ResetPassword = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const resetToken = searchParams.get('token');
    const resetEmail = searchParams.get('email');
    const [showPassword, setShowPassword] = useState(false);
    const [reEnterPassword, setShowReEnterPassword] = useState(false);
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    const toggleReEnterPasswordVisibility = () => {
        setShowReEnterPassword(!reEnterPassword);
    };
    const { control, register, watch, handleSubmit, setValue, setError, clearErrors, formState: { errors } } = useForm();
    const password = watch('password');
    useEffect(() => {
        if (resetToken && resetEmail) {
            dispatch(verifyTokenAsync({
                email: resetEmail,
                token: resetToken.replaceAll(' ', '+')
            }))
                .unwrap()
                .then((response) => {
                if (!response) {
                    navigate('/link-expired');
                }
            });
            setValue('token', resetToken.replaceAll(' ', '+'));
            setValue('email', resetEmail);
        }
    }, [dispatch, navigate, resetEmail, resetToken, setValue]);
    const onSubmit = (credentials) => {
        dispatch(resetPasswordAsync(credentials))
            .unwrap()
            .then((response) => {
            if (response) {
                navigate('/login');
            }
        });
    };
    return (_jsxs("div", { className: 'auth-form-container', children: [_jsx("img", { src: 'images/loginBackgroundImage.png', alt: '', className: 'loginBackground' }), _jsx("form", { onSubmit: handleSubmit(onSubmit), id: 'contact-form', noValidate: true, className: 'auth-form', children: _jsxs("div", { className: 'auth-form-content', children: [_jsx("div", { className: 'login-icon', children: _jsx("img", { src: 'images/MainLogo.png', alt: '', className: 'vn-login-logo' }) }), _jsxs("div", { className: 'form-group mt-5', children: [_jsx("label", { className: 'passwordLabel', children: "Nieuw wachtwoord" }), _jsx(Controller, { name: 'password', control: control, rules: {
                                        required: {
                                            value: true,
                                            message: translate('validations.fieldIsRequired')
                                        },
                                        minLength: {
                                            value: 8,
                                            message: 'Wachtwoord moet minstens 8 tekens lang zijn'
                                        },
                                        validate: {
                                            hasNonAlphanumeric: (value) => /[^a-zA-Z\d]/.test(value) || 'Wachtwoord moet minstens één speciaal karakter bevatten',
                                            hasUppercase: (value) => /[A-Z]/.test(value) || 'Wachtwoord moet minstens één hoofdletter bevatten',
                                            hasLowercase: (value) => /[a-z]/.test(value) || 'Wachtwoord moet minstens één kleine letter bevatten',
                                            hasNumber: (value) => /\d/.test(value) || 'Wachtwoord moet minstens één cijfer bevatten'
                                        }
                                    }, render: ({ field: { onChange, value } }) => (_jsxs("div", { className: 'password-input d-flex justify-content-between align-items-center', children: [_jsx("input", { style: { border: '1px solid #ced4da' }, type: showPassword ? 'text' : 'password', name: 'password', className: 'form-control vn-Input', placeholder: 'Voer nieuw wachtwoord in', onChange: onChange, value: value }), _jsx(IonIcon, { icon: showPassword ? eyeOffOutline : eyeOutline, onClick: togglePasswordVisibility })] })) }), _jsx(VnValidation, { fieldError: errors.password })] }), _jsxs("div", { className: 'form-group mt-5', children: [_jsx("label", { className: 'passwordLabel', children: "Voer nieuw wachtwoord opnieuw in" }), _jsx(Controller, { name: 'reEnterPassword', control: control, rules: {
                                        required: {
                                            value: true,
                                            message: translate('validations.fieldIsRequired')
                                        },
                                        validate: (value) => value === password || 'Wachtwoord komt niet overeen'
                                    }, render: ({ field: { onChange, value } }) => (_jsxs("div", { className: 'password-input', children: [_jsx("input", { style: { border: '1px solid #ced4da' }, type: reEnterPassword ? 'text' : 'password', name: 'password', className: 'form-control vn-Input', placeholder: 'Voer nieuw wachtwoord opnieuw in', onChange: (e) => {
                                                    onChange(e);
                                                    if (e.target.value !== password) {
                                                        setError('reEnterPassword', {
                                                            type: 'manual',
                                                            message: 'Wachtwoord komt niet overeen'
                                                        });
                                                    }
                                                    else {
                                                        clearErrors('reEnterPassword');
                                                    }
                                                }, value: value }), _jsx(IonIcon, { icon: reEnterPassword ? eyeOffOutline : eyeOutline, onClick: toggleReEnterPasswordVisibility, style: { left: '94%' } })] })) }), _jsx(VnValidation, { fieldError: errors.reEnterPassword })] }), _jsx("div", {}), _jsx("div", { className: 'd-grid gap-2 mt-4', children: _jsx("button", { type: 'submit', name: 'submit__form', className: 'submitButton', children: "Indienen" }) })] }) })] }));
};
export default ResetPassword;
